/**
 * Shared account access rules for login and session restore.
 */

export function isUserAccountActive(userData = {}) {
  if (!userData || userData.deleted === true) return false;
  return userData.status !== false;
}

export function getInactiveLoginMessage() {
  return "Your account has been deactivated. Please contact your administrator.";
}

/**
 * Split a client display name into user profile first/last names.
 */
function normalizeRoleList(roleValue) {
  if (Array.isArray(roleValue)) return roleValue.filter(Boolean);
  return roleValue ? [roleValue] : [];
}

/** Display name for user lists; Client portal users often have duplicate first/last from clientName. */
export function formatUserDisplayName(user = {}) {
  const first = String(user?.firstName || "").trim();
  const last = String(user?.lastName || "").trim();
  const isClient = normalizeRoleList(user?.role).some(
    (r) => String(r).toLowerCase() === "client"
  );

  if (!first && !last) return "—";
  if (isClient) {
    if (first && (!last || first.toLowerCase() === last.toLowerCase())) {
      return first;
    }
  }
  if (first && last) return `${first} ${last}`;
  return first || last;
}

export function parseClientDisplayName(clientName = "") {
  const fullName = String(clientName || "").trim();
  if (!fullName) return { firstName: "", lastName: "" };
  const parts = fullName.split(/\s+/).filter(Boolean);
  if (parts.length === 1) {
    return { firstName: parts[0], lastName: "" };
  }
  return { firstName: parts[0], lastName: parts.slice(1).join(" ") };
}
